export interface UpdateDocumentDto {
    id: string;
    documentName: string;
    isPermanent: boolean;
    taskId: string;
    fileMetaDataId?: string;
    externalLinkId?: string;
    expiryDate?: Date;
    externalUrl?: string;
}
